import { DotLottie } from '@lottiefiles/dotlottie-web';

$(document).ready(function () {

    const findTariffForm = $('.find-tariff');
    const comparisonBlock = $('.comparison-info-block');

    comparisonBlock.each( function() {
        const lottieCanvasBox = $(this).find('.lottie-canvas');
        const lottieCanvas = lottieCanvasBox.find('canvas');

        if (lottieCanvas.length > 0) {
            const lottieSrc = lottieCanvas.data('src');
            const lottieLoop = lottieCanvas.data('loop');

            const dotLottie = new DotLottie({
                autoplay: true,
                loop: lottieLoop,
                canvas: lottieCanvas[0],
                src: lottieSrc
            });
        }
    });

    // Household-size slider steps (1-5) <-> preset consumption values. Shared by updateSlider()
    // (user picks a step -> consumption is set to the matching preset) and
    // stepForConsumption() (the reverse: an existing consumption value -> matching step, used
    // to initialize the slider from the field's own value instead of overwriting it).
    const SLIDER_STEP_VALUES = {
        1: 1500, 2: 2500, 3: 3500, 4: 4250, 5: 6500
    };

    function stepForConsumption(consumption) {
        const numeric = parseInt(consumption, 10);

        if (isNaN(numeric)) {
            return null;
        }

        const matchedStep = Object.keys(SLIDER_STEP_VALUES).find(
            (step) => SLIDER_STEP_VALUES[step] === numeric
        );

        return matchedStep ? parseInt(matchedStep, 10) : null;
    }

    // No preset step matches the field's current consumption value - leave that value untouched
    // and show the slider at zero/unfilled rather than forcing it onto a step it doesn't match.
    function resetSliderToZero($container) {
        let $sliderThumb = $container.find('.slider-thumb');
        let $sliderFill = $container.find('.slider-track-fill');
        let $sliderInput = $container.find('.slider-input');

        $sliderFill.css('width', '0px');
        $sliderThumb.css('left', '0px');
        $sliderInput.val(0);

        $container.find('.item-person').removeClass('-filled');
    }

    function checkFields() {
        const inputs = $('.ninja-forms-field');
        inputs.each(function () {
            let $input = $(this);
            let $attr = $(this).attr('required');
            let $container = $input.closest('.nf-field-container');

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }

                if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                    $container.addClass('potentially-required-label');
                }
            }
        });
    }

    function  decodeHtmlEntities(str) {
        let txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }

    function updateSlider($container, value) {
        let $sliderTrack = $container.find('.slider-track');
        let $sliderThumb = $container.find('.slider-thumb');
        let $sliderFill = $container.find('.slider-track-fill');
        let $sliderInput = $container.find('.slider-input');
        let $form = $container.closest('form');
        let $energyInput = $form.find('.energy-input');
        let min = parseInt($sliderInput.attr('min'));
        let max = parseInt($sliderInput.attr('max'));

        if (value >= min && value <= max) {
            let trackUsableWidth = $sliderTrack.width() - $sliderThumb.outerWidth(); // Usable track width accounting for thumb width
            let percent = ((value - min) / (max - min)) * 100;
            let thumbOffset = (percent / 100) * trackUsableWidth; // Calculate thumb offset based on usable width

            $sliderFill.css('width', thumbOffset + 'px');
            $sliderThumb.css('left', thumbOffset + 'px');
        }

        $sliderInput.val(value);
        $energyInput.val(SLIDER_STEP_VALUES[value]);

        // Update visual representation of people icons as filled or unfilled
        $container.find('.item-person').each(function (index) {
            $(this).toggleClass('-filled', index < value);
        });
    }

    function scrollToElem(elem) {
        const $customerSwitcher = $('.customer-switcher');
        let headerHeight = $("header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

        setTimeout(function () {
            $("html, body").animate({
                scrollTop: elem.offset().top - headerHeight
            }, 300);
        }, 100);
    }

    function initializeSliderFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const consumption = parseInt(urlParams.get('consumption'), 10);

        // Check for NaN
        if (isNaN(consumption)) {
            return;
        }

        // Define the threshold values
        const thresholds = [1499, 2499, 3499, 4249, 6499]; //remove -1 form all number

        // Determine the slider value based on the consumption value
        let sliderValue = thresholds.findIndex((threshold, index) => {
            // Handle the last threshold differently to ensure values exactly on the last threshold are handled
            return consumption <= (thresholds[index + 1] || Infinity);
        }) + 1;

        // Adjust sliderValue if it exceeds the number of thresholds
        sliderValue = Math.min(sliderValue, thresholds.length);

        // Ensure sliderValue is within valid range and trigger click
        if (sliderValue > 0 && sliderValue <= thresholds.length) {
            // console.log(`Slider Value: ${sliderValue}`);
            $(document).on('nfFormReady', function () {
                $('.people-for-range .item-person').eq(sliderValue - 1).click();
                $('.energy-input').val(consumption);
            });
        }

        if(findTariffForm.length > 0) {
            scrollToElem(findTariffForm.closest('.wrapper'));
        }
    }

    function checkAndSubmitFormData() {
        const urlParams = new URLSearchParams(window.location.search);
        const postalCode = urlParams.get('postalcode');
        const city = urlParams.get('city');
        const consumption = urlParams.get('consumption');

        // Check if postalCode, city, and consumption are present in the URL parameters
        if (postalCode && city && consumption) {
            // Set the consumption input value
            $('.find-tariff input[name="consumption"]').val(consumption);

            const $select = $('.find-tariff select[name="postalcode_ort"]');
            $select.empty(); // Clear existing options first

            // Add the option that matches the URL parameters first
            let selectedOption = $('<option></option>')
                .attr('value', JSON.stringify({ code: postalCode, city: city }))
                .text(postalCode + ' ' + city);
            $select.append(selectedOption);

            // Set the selected option as active
            $select.val(JSON.stringify({ code: postalCode, city: city })).trigger('change');

            // If postalCodes is defined and not empty, filter the data and add remaining options
            if (typeof postalCodes !== 'undefined' && postalCodes.length > 0) {
                // Use filter to exclude the already added option
                let filteredPostalCodes = postalCodes.filter(function(item) {
                    return item.code !== postalCode || item.city !== city;
                });

                // Add the filtered options to the select element
                let options = filteredPostalCodes.map(function(item) {
                    return $('<option></option>')
                        .attr('value', JSON.stringify({ code: item.code, city: item.city }))
                        .text(item.code + ' ' + item.city);
                });

                // Append all options in one operation for better performance
                $select.append(options).trigger('change');
            } else {
                console.error('postalCodes variable is either undefined or empty.');
            }

            // Clean the URL
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);

            // Submit the form with a delay
            setTimeout(() => {
                $('.find-tariff form').find('[type="submit"]').click();
            }, 100);
        }
    }

    const popupForm = $('.street-popup #street-form-fake');

    if (popupForm.length > 0) {
        const popupFormSelectsAll = $('.street-popup #street-form-fake select.ninja-forms-field');
        const popupFormInputs = $('.street-popup #street-form-fake input.ninja-forms-field');
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein.")
        });

        popupForm.validate({
            ignore: [],
            rules: {
                housenumber: {
                    digits: true
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
            },
            success: function (label, element) {
                $(element).closest('.field-wrap').addClass('nf-pass');
            }
        });

        popupFormSelectsAll.on('change', function () {
            if($(this).hasClass('-filled')) {
                popupForm.validate().element(this);
            }
        });

        popupFormInputs.on('keyup blur change', function () {
            popupForm.validate().element(this);
        });
    }

    function initSelect2() {
        let $select = $('.zip-input');

        // Normalize postalCodes
        const hasData = typeof postalCodes !== 'undefined' && Array.isArray(postalCodes) && postalCodes.length > 0;
        const smallList = hasData && postalCodes.length < 10;
        const postalCodesArray = hasData? postalCodes:[];

        if (smallList) {
            let data = [];

            postalCodesArray.forEach(item => {
                const optionValue = JSON.stringify({ code: item.code, city: item.city });
                const optionText = `${item.code} ${item.city}`;
                data.push({ id: optionValue, text: optionText });
            });

            $select.select2({
                placeholder: "Postleitzahl",
                dropdownParent: $select.parent(),
                data: data,
                multiple: true,
                maximumSelectionLength: 1,
                minimumResultsForSearch: Infinity,
                language: {
                    noResults: function () {
                        return 'Keine Übereinstimmungen gefunden';
                    }
                },
            });

        } else {
            // Initialize select2 with the necessary options
            $select.select2({
                placeholder: "Postleitzahl",
                dropdownParent: $select.parent(),
                multiple: true,
                maximumSelectionLength: 1,
                minimumInputLength: 3,
                language: {
                    inputTooShort: function () {
                        return 'Bitte gib mindestens 3 Zeichen ein'; // message for too few characters
                    },
                    noResults: function () {
                        return 'Keine Übereinstimmungen gefunden'; // no results found message
                    }
                },
                ajax: {
                    transport: function (params, success, failure) {
                        if (typeof postalCodes === 'undefined' || !Array.isArray(postalCodes) || postalCodes.length === 0) {
                            $select.empty();
                            failure();
                            return;
                        }

                        let searchTerm = params.data.term.toLowerCase();

                        // If less than 3 characters, clear the select and do not perform the search
                        if (searchTerm.length < 3) {
                            $select.empty();
                            return;
                        }

                        let isNumeric = /^\d+$/.test(searchTerm); // Check if the search term is a number

                        // Filter the postalCodes array based on the search term
                        let filteredData = postalCodes.filter(function (item) {
                            let combinedText = `${item.code} ${item.city}`.toLowerCase();

                            if (isNumeric) {
                                // If the search term is a number, check if it matches the start of the postal code
                                return item.code.startsWith(searchTerm);
                            } else {
                                // Otherwise, check if the combined text contains the search term
                                return combinedText.includes(searchTerm);
                            }
                        });

                        // Sort the filtered data by postal code in ascending order
                        filteredData.sort(function (a, b) {
                            return a.code.localeCompare(b.code, undefined, {numeric: true});
                        });

                        // If no matching results found, display a message in the console
                        if (filteredData.length === 0) {
                            console.warn('No matching postal codes or cities found for the search term: ' + searchTerm);
                        }

                        // Map filtered data to the format required by select2
                        let results = filteredData.map(function (item) {
                            return {
                                id: JSON.stringify({code: item.code, city: item.city}), // JSON string for value
                                text: item.code + ' ' + item.city // Display postal code and city
                            };
                        });

                        // Return the filtered and sorted results
                        success({
                            results: results
                        });
                    }
                }
            });
        }

        $select.on('select2:open', function() {
            if($select.val().length) {
                let $selectContainer = $(this).next('.select2-container');
                let $searchField = $selectContainer.find('.select2-search__field');

                // Retrieve the text of the first selected item
                let selectedItem = $select.select2('data')[0];
                let selectedText = selectedItem ? decodeHtmlEntities(selectedItem.text) : '';

                // Clear the selected item from Select2
                $select.val(null).trigger('change');
                $searchField.val(selectedText);
                $select.parent().addClass('-loading');

                // Insert the text into the search field for editing
                setTimeout(function () {
                    $searchField.trigger("input");
                    setTimeout(function () {
                        $select.parent().removeClass('-loading');
                    }, 1);
                }, 1);
            }
        });

        $select.on('select2:select', function() {
            let $selectContainer = $(this).next('.select2-container');
            let $searchField = $selectContainer.find('.select2-search__field');

            $searchField.blur();
        });

        $select.on('select2:close', function() {
            // Check if there is a selected item
            if ($select.val().length === 0) {
                let $selectResults = $select.data('select2').results.$results;

                // Find the first item in the results
                let results = $selectResults.find('.select2-results__option');

                if (results.length > 0) {
                    let firstResult = $(results[0]);

                    // Check if the first result is not a message indicating no results found
                    if (!firstResult.hasClass('select2-results__message')) {
                        // Retrieve the text of the first result
                        let firstText = firstResult.text();

                        // Split the text into code and city based on the first space
                        let code = firstText.split(" ", 1)[0]; // First word is the code
                        let city = firstText.slice(code.length + 1); // Remaining text is the city

                        // Create an ID in JSON format, similar to the format used in the ajax function
                        let id = JSON.stringify({ code: code, city: city });

                        // Remove all existing options to avoid duplicates
                        $select.find('option').remove();

                        // Create a new option based on the code and city
                        let option = new Option(firstText, id, true, true);
                        $select.append(option).trigger('change');

                        // Trigger the `select2:select` event to simulate selection
                        $select.trigger({
                            type: 'select2:select',
                            params: {
                                data: { id: id, text: firstText }
                            }
                        });
                    }
                }
            }
        });

        // Optionally call the function to check and submit form data
        checkAndSubmitFormData();
    }

    $(document).on('click', '.slider-container .item-person', function () {
        let $container = $(this).closest('.nf-cell');
        let index = $(this).index() + 1;
        updateSlider($container, index);
    });

    $(document).on('mousedown touchstart', '.slider-container .slider-thumb', function (e) {
        e.preventDefault(); // Prevent default action (like text selection) during drag
        let $container = $(this).closest('.nf-cell');
        let startX = e.pageX || e.originalEvent.touches[0].pageX;
        let startLeft = parseFloat($(this).css('left'));
        let trackWidth = $container.find('.slider-track').width();
        let thumbWidth = $(this).outerWidth();

        function mouseMoveHandler(e) {
            e.preventDefault();
            let currentX = e.pageX || e.originalEvent.touches[0].pageX;
            let diffX = currentX - startX;
            let newLeft = Math.min(Math.max(startLeft + diffX, 0), trackWidth - thumbWidth);
            let newPercent = (newLeft / (trackWidth - thumbWidth)) * 100;
            let min = parseInt($container.find('.slider-input').attr('min'));
            let max = parseInt($container.find('.slider-input').attr('max'));
            let newValue = Math.round(min + (newPercent / 100) * (max - min));
            updateSlider($container, newValue);
        }

        $(document).on('mousemove touchmove', mouseMoveHandler);
        $(document).on('mouseup touchend', function () {
            $(document).off('mousemove touchmove', mouseMoveHandler);
        });
    });

    $(document).on('nfFormReady', function () {
        let heroWrapForm =  $('.hero .wrapper, .multi-step_form_preview .wrapper');
        let sliderInput =  $('.slider-input.hidden-number');
        let $container = sliderInput.closest('.nf-cell');
        let $energyInput = $container.closest('form').find('.energy-input');

        // Slider follows the consumption field's own value (e.g. its Ninja Forms Default
        // Value), not the other way around: if that value matches one of the household-size
        // presets, activate the matching step; otherwise leave the field's value untouched
        // and show the slider at zero rather than forcing it onto an unrelated step.
        let matchedStep = stepForConsumption($energyInput.val());

        if (matchedStep) {
            updateSlider($container, matchedStep);
        } else {
            resetSliderToZero($container);
        }

        checkFields();
        initSelect2();

        heroWrapForm.addClass('show');
    });

    $(document).on('focus', '.ninja-forms-field', function () {
        let $input = $(this);
        let $container = $input.closest('.nf-field-container');

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    });

    $(document).on('blur', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let value = $input.val();

        const isEmpty = $.isArray(value)
            ? value.length === 0
            : String(value ?? '').trim() === '';

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');

        if (typeof $attr !== 'undefined' && $attr !== false) {
            $container.toggleClass('required-label', isEmpty);
        }
    });

    $(document).on('input', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let value = $input.val();

        if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }
    });

    // Initialize slider on page load based on URL parameter
    initializeSliderFromURL();

    // Use jQuery since Ninja Forms utilizes jQuery
    jQuery(document).on('nfFormReady', function (e, layoutView) {
        // Select the postal code fields
        var $postalCodeFields = jQuery('input[name="postalcode"]');

        // Function to update the state of the submit button
        function updateSubmitButtonState($row, isDisabled) {
            var $submitButton = $row.find('input[type="submit"]');
            $submitButton.attr('aria-disabled', isDisabled ? 'true' : null); // Set aria-disabled attribute
            $submitButton.prop('disabled', isDisabled); // Set disabled property
        }

        // Function to validate postal code field
        function validatePostalCodeField($field) {
            var value = $field.val();
            // Validate that the value contains only digits and is at least 5 digits long
            var isValid = /^\d{5,}$/.test(value);

            // Determine the closest form row
            var $row = $field.parents('.nf-row');

            if (!isValid) {
                // Add error class and remove pass class if validation fails
                $field.closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
                updateSubmitButtonState($row, true); // Disable the submit button
            } else {
                // Remove error class and add pass class if validation succeeds
                $field.closest('.field-wrap').removeClass('nf-error').addClass('nf-pass');
                updateSubmitButtonState($row, false); // Enable the submit button
            }
        }

        // Function to filter input to allow only digits
        function filterInputToDigits(event) {
            var $this = jQuery(this);
            // Remove any non-digit characters
            var filteredValue = $this.val().replace(/\D/g, '');
            $this.val(filteredValue);

            // Trigger validation after filtering
            validatePostalCodeField($this);
        }

        // Apply filtering and validation to both postal code fields
        $postalCodeFields.on('input', filterInputToDigits);
    });
});
